import CloseIcon from "../../../assets/icons/close-icon-red.svg";
import "./ToastNotification.scss";
import { useEffect } from "react";

interface ToastNotificationProps {
  alertType: string;
  alertMsg: string;
  closeAlert: () => void;
}

function ToastNotification({ alertType, alertMsg, closeAlert }: ToastNotificationProps) {

  useEffect(() => {
    if (alertType !== "") {
      setTimeout(() => {
        closeAlert();
      }, 10000)
    }
  }, [alertType, closeAlert])

  return (
    <div className={"alert" + (alertType ? " " + alertType : " no-display")}>
      <div className="alert__wrap">
        <span className="alert__alert-msg">{alertMsg}</span>
      </div>
      <img src={CloseIcon} alt="close icon" className="alert__close-icon" onClick={closeAlert} />
    </div>
  );
}

export default ToastNotification;
